<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Imagenes de Fondo" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Login de Usuarios" @click='pickFile("a1")' v-model='file_a_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a1" accept=".png" @change="onFilePicked" >
                                                <!-- fondo.png -->
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Barra Lateral" @click='pickFile("a2")' v-model='file_a_2' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a2" accept=".png" @change="onFilePicked" >
                                                <!-- barra.png -->
                                                
                                            </v-flex>
                                             <v-flex xs12>
                                                <v-text-field label="Registro" @click='pickFile("a3")' v-model='file_a_3' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a3" accept=".gif" @change="onFilePicked" >
                                                <!-- registro.gif -->
                                                
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Login SolucionA31" @click='pickFile("a4")' v-model='file_a_4' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a4" accept=".png" @change="onFilePicked" >
                                                <!-- registro.gif -->
                                                
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Login SolucionA24" @click='pickFile("a5")' v-model='file_a_5' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a5" accept=".png" @change="onFilePicked" >
                                                <!-- registro.gif -->
                                                
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                       
                        
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {

    },
    data() {
        return {
            fab: false,

            file_a_1: "",
            file_a_2: "",
            file_a_3: "",
            file_a_4: "",
            file_a_5: "",

            show_loading: true,

            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Imagenes de Fondo",
                    disabled: true,
                    href: ""
                }
            ],
            selected: "",
            title: "",
            modal: false,
            update: false,
            estados: [],
            size_file: 0,
            type_file: 'application/pdf',
            rules: {
                required: v => !!v || "Este campo es requerido",
            },

        };
    },

    methods: {
        pickFile(id) {
            if (id == 'a1'){
                this.selected='fondo.png'; 
                this.$refs.a1.click();
            } 
            if (id == 'a2') {
                this.selected='barra.png'; 
                this.$refs.a2.click();
            }
            if (id == 'a3') {
                this.selected='registro.gif'; 
                this.$refs.a3.click();
            }
            if (id == 'a4') {
                this.selected='fondosa31.png'; 
                this.$refs.a4.click();
            }
            if (id == 'a5') {
                this.selected='fondosa24.png'; 
                this.$refs.a4.click();
            }
            
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }
                   // console.log(this.selected);
                   this.uploadFile(files[0], this.selected);
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var thisObj = this;

            var keyFile = referencia;

            var datos = {
                key: keyFile,
                bucket: "descargas.econnectpro.mx",
                type: thisObj.type_file
            }
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {
                                headers: {
                                    'Content-Type': thisObj.type_file
                                }
                            })
                            .then((res) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "El archivo se actualizó correctamente",
                                    footer: '',
                                });
                            })
                            .catch((error) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    thisObj.$root.$dialogLoader.hide();
                });

        },

    }
};
</script>
